import { useLocalizationString } from "src/store/localization/useSelectors";
import { getSeparatorForLocalization } from "../table/cells/useGetFormattedDecimalValue/utils";

const useDecimalSeparator = (): string => {
  const locale = useLocalizationString();
  return getSeparatorForLocalization(locale);
};

export default useDecimalSeparator;
